import React from 'react';
import ReactDOM from 'react-dom/client';
import '@linktivity/link-styles';
import '@kurotetsu/agent/apis/fetchUtils';
import '@kurotetsu/agent/styles/index.css';
import '@kurotetsu/agent/i18n';
import App from '@kurotetsu/agent/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
